import React from 'react';
export default function AdminHelp() {
  return (
    <div className='p-8'>
      <h1 className='text-2xl font-bold mb-4'>Help</h1>
      <p>Help, FAQ, and contact information. (Placeholder)</p>
    </div>
  );
} 